export default "__VITE_ASSET__BUGzXFKL__"